var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flexs"},[_c('sidebarUserInfo',{staticStyle:{"flex":"0 0 300px","height":"fit-content"}}),_c('div',{staticStyle:{"flex":"1"}},[_c('top-banner',{staticClass:"banners"}),_c('dealer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }